import React from 'react';
// COMPONENTS
import Title from 'components/text/Title';
import Subtitle from 'components/text/Subtitle';
import Body from 'components/text/Body';
import Button from 'components/common/Button';
// ANTD
import Select from 'antd/lib/select';
import notification from 'antd/lib/notification';

const Option = Select.Option;

const SEND_TYPE_GRAPH = [
  { sendSMS: true, sendEmail: true },
  { sendSMS: true, sendEmail: false },
  { sendSMS: false, sendEmail: true },
];

class SessionReminderForm extends React.PureComponent {
  state = {
    sendType: 0,
    daysBefore: 10,
    loading: false,
  };

  onOk = () => {
    let params = {
      ...SEND_TYPE_GRAPH[this.state.sendType],
      daysBefore: this.state.daysBefore,
    };
    this.setState({ loading: true });
    setTimeout(() => {
      notification.success({ message: 'Reminder added!' });
      this.setState({ loading: false });
      this.props.onCancel();
    }, 1000);
  };

  onDaysBeforeChange = daysBefore => {
    this.setState({ daysBefore });
  };

  onSendTypeChange = sendType => {
    this.setState({ sendType });
  };

  render() {
    const defaultButtonProps = {
      size: 'large',
      disabled: this.state.loading,
      style: {
        flex: 1, flexDireciton: 'column', margin: 10, minWidth: '30%',
      },
    };

    return (
      <div style={s.container}>
        <Title>Automatically send a reminder to your client?</Title>
        <Subtitle>We can send them an SMS or Email, just pick when.</Subtitle>
        <div style={{ flexDirection: 'row', width: '100%', padding: 25 }}>
          <Body>
            Send{' '}
            <Select onChange={this.onSendTypeChange} defaultValue={this.state.sendType} style={{ width: 155 }}>
              <Option value={0}>Email & SMS/Text</Option>
              <Option value={1}>SMS/Text</Option>
              <Option value={2}>an Email</Option>
            </Select>{' '}
            reminder{' '}
            <Select onChange={this.onDaysBeforeChange} defaultValue={10} style={{ width: 50 }}>
              <Option value={30}>30</Option>
              <Option value={15}>15</Option>
              <Option value={10}>10</Option>
              <Option value={5}>5</Option>
              <Option value={3}>3</Option>
              <Option value={2}>2</Option>
              <Option value={1}>1</Option>
            </Select>{' '}
            day(s) before session.
          </Body>
        </div>
        <div style={{ flexDirection: 'row', width: '100%', padding: 15 }}>
          <Button {...defaultButtonProps} type="primary" onClick={this.onOk} loading={this.state.loading}>
            {this.state.loading ? 'Submitting...' : 'Yes'}
          </Button>
          <Button {...defaultButtonProps} type="ghost" onClick={this.props.onCancel}>
            No
          </Button>
        </div>
      </div>
    );
  }
}

const s = {
  container: {
    minHeight: 175,
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default SessionReminderForm;



// WEBPACK FOOTER //
// ./src/components/forms/SessionReminderForm/index.js